import z from 'zod'

export const CredentialsSchema = z.object({
  accessToken: z.string().min(48),
  expiresIn: z.number(),
  refreshToken: z.string().min(48),
  scope: z.optional(z.literal(null)),
  tokenType: z.literal('bearer'),
})

export const AuthResponseSchema = z.object({
  access: CredentialsSchema.extend({
    expirationTime: z.number(),
    twoFactorToken: z.string().nullable(),
  }),
  twoFactor: z.object({
    expiresIn: z.number(),
    twoFactorToken: z.string().nullable(),
  }),
})
export type Credentials = z.infer<typeof CredentialsSchema>
export type AuthResponse = z.infer<typeof AuthResponseSchema>
